const isIntegratedFormsApp = () => {
  if (!document.referrer || !window.hubspot) {
    return false;
  }

  const referrer = new URL(document.referrer);
  const portalId = window.hubspot.portal && window.hubspot.portal.id;
  return referrer.pathname === `/integrated-forms-ui/${portalId}/create/type`;
};

export default {
  isIntegratedFormsApp
};